"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.customModel.exceeded': 'Custom AI model limit reached. Upgrade your plan to train more models.',
    'limits.customModel.limitReached': 'Custom model limit: {limit} (upgrade to train more)',
};
